import React from "react";
import { FlexContainer } from "src/components";
import {
    TextLabel,
    ErrorMessage
} from "../../style";
import RichTextEditor from "src/components/RichTextEditor/RichTextEditor";

export const ArticleDescriptionField = ({ htmlContent, onChange, error }) => {
    return (
        <FlexContainer>
            <TextLabel color="#000000" fontSize="16px" fontWeight="bold"
            >
                Article Description
            </TextLabel>
            <RichTextEditor
                setContent={onChange}
                initialValue={htmlContent}
                placeholder="Write a short article to expand on the meaning of your quote…"
            />
            <ErrorMessage>{error}</ErrorMessage>
        </FlexContainer>
    );
};
